import { render, staticRenderFns } from "./CreatePaymentVoucher.vue?vue&type=template&id=6a5d68cb"
import script from "./CreatePaymentVoucher.vue?vue&type=script&lang=js"
export * from "./CreatePaymentVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports